export default {
  maxFileSize: 100,
  ADDITIONAL_FILE_TYPES: {
    FINAL_TERMS: 'final-terms',
    ADDENDUM: 'addenda'
  }
}
